// CTASection.tsx
import React from 'react';
import { Button } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';

function CTASection() {
  const navigate = useNavigate();

  return (
    <div className={styles.ctaSection}>
      <div className={styles.ctaContent}>
        <h2 className={styles.ctaTitle}>
          Ready to Discuss Your Next Transaction?
        </h2>
        <p className={styles.ctaText}>
          We're here to help you structure deals, minimize risk, and move
          forward with confidence.
        </p>
        <Button
          type="primary"
          size="large"
          icon={<PhoneOutlined />}
          className={styles.ctaButton}
          onClick={() => navigate('/contact')}
        >
          Schedule a Consultation
        </Button>
      </div>
    </div>
  );
}

export default CTASection;
